// Layout helpers for aspect-ratio-preserving images placed inside a rect
// (shared by Image.jsx and Glyph.jsx).

// free = empty space along an axis; 0 = start, /2 = center, full = end.
const align = (free, alignment) => {
  switch (alignment) {
    case 'CENTER':
    case 'MIDDLE':
      return free / 2;
    case 'RIGHT':
    case 'BOTTOM':
      return free;
    default:
      return 0;
  }
};

// The rendered image size depends on which dimension is the limiting one:
// when the rect is relatively wider than the image, height is the constraint,
// otherwise width is.
export const getImageCoordinates = ({
  rectProps,
  rectFactor,
  imageFactor,
  scaleFactor,
  horizontalAlignment,
  verticalAlignment,
}) => {
  const renderedWidth =
    rectFactor > imageFactor
      ? rectProps.height * scaleFactor * imageFactor
      : rectProps.width * scaleFactor;
  const renderedHeight =
    rectFactor > imageFactor
      ? rectProps.height * scaleFactor
      : (rectProps.width * scaleFactor) / imageFactor;

  return {
    x: align(rectProps.width - renderedWidth, horizontalAlignment),
    y: align(rectProps.height - renderedHeight, verticalAlignment),
  };
};
